import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/Home'
import product from '@/view/product/product'
import solve from '@/view/solve/solve'
import channel from '@/view/channel/channel'
import about from '@/view/about/about'
import details from '@/view/about/details'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/product',
      name: 'product',
      component: product
    },
    {
      path: '/solve',
      name: 'solve',
      component: solve
    },
    {
      path: '/channel',
      name: 'channel',
      component: channel
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/details',
      name: 'details',
      component: details
    }
  ],
  scrollBehavior(to, from, savedPosition) { // 解决vue页面之间跳转，页面不是在顶部的问题
    return { x: 0, y: 0 }
  },
  mode: 'history',
  srcollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js